<template>
	<Loader v-if="loading" />
	<div v-else data-testid="orders-content" class="content">

		<Modal v-if="create_order" v-on:close="create_order = false;">
			<h2 style="margin-top: 0px;" class="margin-bottom">Create order</h2>
			<CreateOrder />
		</Modal>

		<Modal
			v-if="clone"
			v-on:close="clone = false">
			<OrderCloning />
		</Modal>

		<div class="content margin-bottom">
			<div class="flex">
				<h1>Orders</h1>
				<div class="flex-grow text-right">
					<button v-on:click="create_order = true;">Create order</button>
					<button
						class="small-margin-left"
						v-on:click="clone = true">Clone</button>
				</div>
			</div>
			<div class="small-margin-bottom margin-top">
				<strong>Filter:</strong>
			</div>
			<div class="flex margin-bottom">
				<!-- <div class="margin-right">
					<input type="checkbox" />
					[ coming soon to a backend near you ]
				</div> -->
			</div>
		</div>
		<div>
			<Table :columns="columns" :rows="getRows" />
		</div>
		<Modal v-if="showCancelModal"  v-on:close="showCancelModal = false;" >
			<CancelOrder @closeModal="toggleCancelModal" :id="getOrderId" :order_status="getOrderStatus" @success="handleSuccess"  />
		</Modal>
	</div>
</template>

<script>
import Vue from 'vue'
import CancelOrder from '@/components/CancelOrder.vue'
import CreateOrder from '@/components/orders/CreateOrder.vue'
import OrderCloning from '@/components/cloning/OrderCloning.vue'

export default {
  components: {
    CancelOrder,
    CreateOrder,
    OrderCloning
  },
  data: () => ({
    clone: false,
    create_order: false,
    loading: false,
    showCancelModal: false,
    currentRow: '',
    rows: [],
    columns: {
      order_id: {},
      order_status: {}
    }
  }),
  computed: {
    getRows () {
      return this.rows
    },

    getOrderId () {
      return this.currentRow.id
    },

    getOrderStatus () {
      return this.currentRow.order_status
    }
  },
  methods: {
    load () {
      Vue.api.get('/order?desc=1&limit=100', {}, {
        before: () => this.loading = true,
        always: () => this.loading = false,
        callback: data => this.parse(data)
      })
    },
    parse (data) {
      this.rows = data.map(row => {
        row.order_id = {
          type: 'order-link',
          // url: `${process.env.VUE_APP_WP_URL}/post.php?post=` + order.id + '&action=edit',
          order_id: row.id
        }

        row.menu = [{
          name: 'Cancel',
          onClick: (row) => this.toggleCancelModal(row),
          disabled: this.isCancelled(row)
        }]

        return row
      })
    },

    toggleCancelModal (row) {
      this.currentRow = row
      this.showCancelModal = !this.showCancelModal
    },
    isCancelled (row) {
      const status = ['wc-cancelled', 'wc-fee_cancelled', 'wc-exchanges_cancell', 'wc-webshop_cancelled']
      return status.indexOf(row.order_status) !== -1
    },
    handleSuccess () {
      this.toggleCancelModal()
      this.load()
    }
  },
  created () {
    this.load()
  }
}
</script>
